import React from 'react';
import { useLocation } from 'react-router-dom';
import '../translations/i18n';
import parse from 'html-react-parser';
import { useGetSeoQuery } from '../services/api';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { useConfig } from '../hooks/config';
import { useAuth } from '../hooks/auth';
import Message from './Message';
import Header from './Header';
import Footer from './Footer';
import { Lottie } from './Loading';
import { useLayout } from '../hooks/layout';
import { Container, Box, Backdrop } from '@mui/material';

/*
<Helmet
    title={article.get('title')}
    meta={[
        {"property": "og:title", "content": article.get('title')},
        {"property": "og:url", "content": article.get('url')},

        {"property": "twitter:title", "content": article.get('title')}
    ]}
    script={[
            {"src": "http://url.com/script.js", "type": "text/javascript"}
    ]}
/>
*/

export default function Layout(props) {

  const { seo, loading, containerProps, children } =  props;
  const location = useLocation();
  const { config, isFetchingConfig } = useConfig();
  const { auth, isFetchingUser } = useAuth();
  const { t } = useTranslation();
  const { theme } = useLayout();
  const [ metas, setMetas ] = React.useState([]);
  const { data: fetchedSeo, isFetching: isFetchingSeo, isSuccess: isSuccessSeo } = useGetSeoQuery({
    path: location.pathname,
    query: location.search.replace('?', '')
  }, {
    refetchOnMountOrArgChange: true,
    skip: Boolean(seo.metas) || loading
  });

  const parseMetas = (metas) => {
    return metas.map((meta) => parse(meta, {
      replace: ({ attribs, children }) => {
        if(!attribs) {
          return;
        }
        if(attribs.type === 'application/ld+json') {
          if(children && children.length) {
            return (
              <script type="application/ld+json">
                {children[0].data}
              </script>
            );
          }
        }
      }
    }))
  }

  React.useEffect(() => {
    if(Boolean(seo.metas)) {
      setMetas([...parseMetas(seo.metas)]);
    } else if(isSuccessSeo) {
      setMetas([...parseMetas(fetchedSeo.metas)]);
    }
  }, [seo, location, fetchedSeo]);

  return (
    <Box
      bgcolor={theme.palette.cream.main}
    >
      <Helmet>
        {
          metas.map((meta, i) => (
            React.cloneElement(meta, {key: 'meta-'+i})
          ))
        }
      </Helmet>
      <Header />
      <Container 
        sx={{
          pb: 3,
          minHeight: '100vh'
        }}
        {...containerProps}
      >
        { children }
        <Message />
      </Container>
      <Footer />
      <Backdrop
        sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={Boolean(loading)}
      >
        <Lottie animation="loading" />
      </Backdrop>
    </Box>
  );
}